import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

const slider = document.querySelector(".patient-reviews-slider__slider");

if (slider) {
    var splide = new Splide(slider, {
        type: "slider",
        rewind: true,
        speed: 1000,
        pagination: false,
        perPage: 2.3,
        perMove: 1,
        arrows: true,
        breakpoints: {
            960: {
                perPage: 1
            }
        },
    });

    // splide.on("mounted", function () {
    //     var slides = splide.Components.Elements.slides;

    //     slides.forEach(function (slide, index) {
    //     slide.style.opacity = index === 0 ? 1 : 0.5;
    //     });
    // });

    // splide.on("moved", function () {
    //     var slides = splide.Components.Elements.slides;

    //     slides.forEach(function (slide, index) {
    //     slide.style.opacity = 0.5;
    //     });

    //     var currentSlide = slides[splide.index];
    //     currentSlide.style.opacity = 1;
    // });

    splide.mount();
}